//Clone of m23 GameStatistics

import React from "react";
import { isPortrait } from "@/modules/commonMobile";
import { ILongerGameStatisticsProps } from "@/types/LongerStatisticsTypes";
import { beadJSX, processMultilineStatistics } from "@/modules/statistics";
import { getDTCardValue } from "@/modules/cards";

interface IProps extends Omit<ILongerGameStatisticsProps, "history"> {
	history: IDragonTigerRoadmapItemType[];
}

interface IDragonTigerRoadmapItemType {
	dragon: string;
	tiger: string;
	result: string;
	idnomor: number;
	gamekey: string; // "2",
	periode: number; // 8
	
	//Done in runtime
	win: string;
}

export default class M23 extends React.Component<IProps> {
	statisticsArray = [];
	
	filtrate(history: IDragonTigerRoadmapItemType[]) {
		const blackSuits = ["s", "c"];
		
		//Counters
		let dragons = 0, tigers = 0, ties = 0,
			dragonEvens = 0, dragonOdds = 0,
			tigerEvens = 0, tigerOdds = 0,
			dragonBigs = 0, dragonSmalls = 0,
			tigerBigs = 0, tigerSmalls = 0,
			dragonBlacks = 0, dragonReds = 0,
			tigerBlacks = 0, tigerReds = 0;
		
		//Process history here
		history.forEach((item) => {
			if (item.win === "dragon")
				dragons++;
			else if (item.win === "tiger")
				tigers++;
			else ties++;

			const dragonVal = getDTCardValue(item.dragon);
			const tigerVal = getDTCardValue(item.tiger);
			
			if (dragonVal % 2)
				dragonOdds++;
			else dragonEvens++;
			
			if (tigerVal % 2)
				tigerOdds++;
			else tigerEvens++;
			
			if (dragonVal <= 5)
				dragonSmalls++;
			else dragonBigs++;
			
			if (tigerVal <= 5)
				tigerSmalls++;
			else tigerBigs++;
			
			if (blackSuits.indexOf(item.dragon[1]))
				dragonBlacks++;
			else dragonReds++;
			
			if (blackSuits.indexOf(item.tiger[1]))
				tigerBlacks++;
			else tigerReds++;
		});
		
		//Static cells
		const statisticsCells = {
			top: [
				beadJSX("circle", "red", "D"),
				beadJSX("circle", "blue", "T"),
				beadJSX("circle", "green", "T"),

				beadJSX("circle-hollow", "blue", "E"),
				beadJSX("circle-hollow", "blue", "O"),

				beadJSX("circle-hollow", "red", "E"),
				beadJSX("circle-hollow", "red", "O"),

				beadJSX("circle", "blue", "B"),
				beadJSX("circle", "blue", "S"),

				beadJSX("circle", "red", "B"),
				beadJSX("circle", "red", "S"),
			
				beadJSX("circle-hollow", "red", "B"),
				beadJSX("circle-hollow", "red", "R"),
			
				beadJSX("circle-hollow", "blue", "B"),
				beadJSX("circle-hollow", "blue", "R")
			],
			bottom: [
				dragons,
				tigers,
				ties,
				dragonEvens,
				dragonOdds,
				tigerEvens,
				tigerOdds,
				dragonBigs,
				dragonSmalls,
				tigerBigs,
				tigerSmalls,
				dragonBlacks,
				dragonReds,
				tigerBlacks,
				tigerReds
			].map((item, idx) => <div key={"m23_" + idx}>{item}</div>)
		};

		//Output
		const cellsPerLine = 5;
		this.statisticsArray = [];

		processMultilineStatistics(this.statisticsArray, statisticsCells, cellsPerLine, isPortrait(),
			"m23");
	}

	render() {
		if (!this.props.history)
			return null;

		this.filtrate(this.props.history);
		
		const statisticsTable = (
			<table><tbody>
				{ this.statisticsArray }
			</tbody></table>
		);
		
		return (
			<div className={"game-statistics m23" +
					(isPortrait() ? " multiline" : "") +
					(this.props.baccaratDarkMode ? " dark" : "")
				}>

				{statisticsTable}
			</div>
		);
	}
}